/**
 * Prefixes a frontend path with the base path.
 * Use for paths that are frontend routes or frontend-served assets.
 * Do NOT use for API/auth paths (/api, /ws, /login, /logout, /auth).
 */
export const withBasePath = (path: string): string => {
  if (!window.APP_BASE_PATH) return path;
  // replace any trailing slash from app base path
  const base = window.APP_BASE_PATH.replace(/\/+$/, '');
  if (path.startsWith(`${base}/`) || path === base) return path;
  return `${base}${path}`;
};
